export default {
  title: 'Integração do Wolt Drive',
  subtitle: 'Visível apenas para gestores de integração.',
  steps: {
    request: {
      title: '1. Solicitar o estabelecimento ao Wolt',
      description:
        'Copia a linha deste restaurante para a folha partilhada do Wolt. Cole-a na coluna A da próxima linha vazia e avise o Wolt no canal partilhado do Slack.',
    },
    activate: {
      title: '2. Verificar e ativar',
      description:
        'Introduza o ID de estabelecimento que o Wolt adicionou à folha. É verificado com um orçamento de teste do Wolt antes de ser guardado.',
    },
  },
  fields: {
    venue_id: {
      label: 'ID de estabelecimento Wolt',
      placeholder: 'ex.: 6736f9f5f9e2ab82f9150420',
      invalid: 'Um ID de estabelecimento Wolt tem 24 caracteres e usa apenas 0–9 e a–f.',
    },
    priority: {
      label: 'Prioridade de fornecedor',
      options: {
        wolt_primary: 'Wolt primário, manter fornecedores atuais como reserva',
        wolt_only: 'Apenas Wolt',
      },
    },
  },
  verification: {
    verified: 'O Wolt confirmou este estabelecimento.',
    failed: 'O Wolt não conseguiu confirmar este estabelecimento.',
    wolt_reason: 'O Wolt indicou: {{reason}}',
    unavailable_now:
      'A Wolt não pode entregar a partir deste estabelecimento neste momento ({{reason}}). Pode mesmo assim guardá-lo.',
  },
  preview: {
    label: 'Ordem dos fornecedores',
    none: 'nenhum',
  },
  hints: {
    internal_delivery:
      'Este restaurante entrega com os seus próprios estafetas. O Wolt é usado quando o modo de entrega abaixo estiver definido para estafetas externos.',
    invalid_stored_id:
      'O ID de estabelecimento guardado {{venueId}} não é um ID de estabelecimento Wolt válido, pelo que a Wolt não é usada para este restaurante. Verifique e guarde o correto.',
  },
  buttons: {
    copy_details: 'Copiar detalhes',
    verify: 'Verificar',
    save: 'Guardar',
  },
  confirm: {
    title: 'Ativar o Wolt Drive?',
    description: 'Guarda o ID de estabelecimento {{venueId}} e altera a ordem dos fornecedores para: {{providers}}.',
    unsaved_providers: 'As alterações não guardadas à lista de fornecedores abaixo serão substituídas.',
    ok: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    copied: 'Copiado',
    copy_failed: 'Não foi possível copiar os detalhes. Tente novamente.',
    saved: 'O Wolt Drive está configurado para este restaurante.',
    save_failed: 'Não foi possível guardar. Tente novamente.',
  },
};
